export default "__VITE_ASSET__efyHxk$q__"